import styled from "styled-components";
import { Row, Card } from "react-bootstrap";

import rectangleGrayBackground from "../../../image/aboutUs/about-us-gray-background.svg";
import graphGrayBackground from "../../../image/aboutUs/graph-gray-background.png";
import responsiveGray1 from "../../../image/aboutUs/responsive-gray1.png";
import responsiveGray2 from "../../../image/aboutUs/responsive-gray2.png";

export const StyledSection = styled.section`
  &.first-gray-background {
    background: url(${rectangleGrayBackground}) no-repeat;
    background-size: 100% 100%;
    background-position-y: -2rem;
    height: 45rem;
    @media screen and (max-width: 1200px) {
      height: 55rem;
    }
    @media screen and (max-width: 992px) {
      background: url(${responsiveGray1}) no-repeat;
      background-size: 100% 100%;
    }
    @media screen and (max-width: 768px) {
      height: 48rem;
    }
  }
  p {
    line-height: 28px;
    text-align: justify;
    font-size: var(--font-size-md);
    color: var(--tertiary-color);
    @media screen and (max-width: 768px) {
      font-size: var(--font-size-sm);
      line-height: 22px;
    }
  }
  &.why-azeto {
    padding: 3rem 0 5rem;
    @media screen and (max-width: 576px) {
      padding: 3rem 0;
    }
    @media screen and (min-width: 992px) {
      margin-top: -4rem;
    }
  }
  &.last-gray-background {
    background: url(${graphGrayBackground});
    background-size: 100% 100%;
    @media screen and (max-width: 1218px) {
      background: url(${responsiveGray2}) no-repeat;
      background-size: 100% 100%;
      height: 65rem;
    }
  }
`;

export const StyledRow = styled(Row)`
  row-gap: 4rem;
  grid-row-gap: 4rem;
`;

export const CardsWrapper = styled(Card)`
  max-width: 305px;
  height: 335px;
  box-shadow: var(--box-shadow3);
  border: none;
  border-radius: 16px;
  background: var(--white-color);
  @media screen and (max-width: 1225px) {
    margin-top: 40px;
    max-width: 304px;
    height: 310px;
  }
  @media screen and (max-width: 320px) {
    max-width: 240px;
    height: 330px;
  }
  .hat-styles {
    transform: translate(5px, 0px);
  }
`;
export const CardBody = styled(Card.Body)`
  .title {
    font-weight: 500;
    font-size: var(--font-size-xl);
    text-align: center;
    color: var(--text-color-dark);
  }
  .subtitle {
    line-height: 25px;
    height: auto;
    font-weight: 400;
    font-size: var(--font-size-base);
    text-align: center;
    color: var(--text-color-dark);
    @media screen and (max-width: 320px) {
      width: 200px;
    }
  }
`;
export const CircleIcon = styled.span`
  background: ${({ $backgroundColor }) => $backgroundColor};
  position: absolute;
  width: 145px;
  height: 145px;
  top: -70px;
  @media screen and (max-width: 576px) {
    width: 130px;
    height: 130px;
  }
  img {
    @media screen and (max-width: 576px) {
      width: 70px;
      height: 70px;
    }
  }
`;
export const GraphWrapper = styled.div`
  margin-top: -10rem;
  height: 600px;
  @media screen and (max-width: 1219px) {
    margin-top: -4rem;
    width: 300px;
    height: 100%;
  }
  @media screen and (max-width: 334px) {
    width: 100%;
  }
  .nodes-Graph {
    position: absolute;
    border: 15px solid var(--secondary-color);
    border-radius: 50%;
    font-weight: 500;
    font-size: var(--font-size-md);
    line-height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: var(--text-color-dark);
    @media screen and (max-width: 1218px) {
      border: 10px solid var(--secondary-color);
      font-weight: 500;
      font-size: var(--font-size-sm);
    }
  }
  .node1 {
    width: 150px;
    height: 150px;
    top: 150px;
    left: 3rem;
    @media screen and (max-width: 1218px) {
      top: 23rem;
      left: 3rem;
      width: 100px;
      height: 100px;
    }
  }
  .node2 {
    width: 150px;
    height: 150px;
    left: 12rem;
    top: 270px;
    @media screen and (max-width: 1218px) {
      top: 30rem;
      right: 1rem;
      width: 120px;
      height: 120px;
    }
  }
  .node3 {
    width: 165px;
    height: 160px;
    top: 210px;
    left: 25rem;
    @media screen and (max-width: 1218px) {
      top: 18rem;
      right: 1rem;
      width: 110px;
      height: 110px;
    }
  }
  .node4 {
    width: 150px;
    height: 150px;
    top: 260px;
    left: 39rem;
    @media screen and (max-width: 1392px) {
      width: 120px;
      height: 120px;
      top: 400px;
      left: 33rem;
    }
    @media screen and (max-width: 1218px) {
      top: 5rem;
      right: 0.5rem;
      width: 100px;
      height: 100px;
    }
  }
  .node5 {
    width: 160px;
    height: 160px;
    top: 230px;
    right: 20rem;
    @media screen and (max-width: 1218px) {
      top: 10rem;
      right: 8rem;
      left: 2rem;
      width: 120px;
      height: 120px;
    }
  }
  .node6 {
    width: 170px;
    height: 170px;
    padding: 10px;
    top: 350px;
    right: 9rem;
    @media screen and (max-width: 1218px) {
      top: 41rem;
      right: 2rem;
      width: 130px;
      height: 130px;
    }
  }
  .node7 {
    width: 130px;
    height: 130px;
    top: 210px;
    right: 3rem;
    @media screen and (max-width: 1218px) {
      top: 35rem;
      right: 11rem;
      width: 100px;
      height: 100px;
    }
  }
  .lines-graph {
    position: absolute;
    width: 70px;
    height: 15px;
    background: var(--secondary-color);
    @media screen and (max-width: 1218px) {
      height: 10px;
    }
  }
  .line1 {
    left: 10rem;
    top: 280px;
    width: 60px;
    transform: rotate(45deg);
    @media screen and (max-width: 1218px) {
      transform: rotate(-30.75deg);
      top: 10rem;
      left: 9rem;
    }
    @media screen and (max-width: 320px) {
      right: 6rem;
    }
  }
  .line2 {
    left: 21rem;
    width: 80px;
    top: 320px;
    transform: rotate(-23.75deg);
    @media screen and (max-width: 1218px) {
      transform: rotate(44deg);
      top: 17rem;
      right: 6rem;
      width: 63px;
    }
  }
  .line3 {
    left: 35rem;
    top: 300px;
    transform: rotate(9.81deg);
    @media screen and (max-width: 1392px) {
      transform: rotate(60deg);
      width: 85px;
      left: 32rem;
      top: 370px;
    }
    @media screen and (max-width: 1218px) {
      transform: rotate(-27.55deg);
      top: 23rem;
      right: 7rem;
      width: 63px;
    }
    @media screen and (max-width: 320px) {
      width: 5rem;
    }
    @media screen and (max-width: 280px) {
      top: 24rem;
      right: 6rem;
      width: 2.8rem;
    }
  }
  .line4 {
    right: 29.5rem;
    top: 310px;
    width: 84px;
    transform: rotate(-15.04deg);
    @media screen and (max-width: 1392px) {
      transform: rotate(-40deg);
      width: 96px;
      right: 28rem;
      top: 370px;
    }
    @media screen and (max-width: 1218px) {
      transform: rotate(45deg);
      top: 30rem;
      right: 7rem;
      width: 77px;
    }
    @media screen and (max-width: 320px) {
      width: 89px;
    }
  }
  .line5 {
    right: 18rem;
    width: 70px;
    top: 370px;
    transform: rotate(34.22deg);
    @media screen and (max-width: 1218px) {
      transform: rotate(-25.22deg);
      top: 35rem;
      right: 8rem;
      width: 70px;
    }
  }
  .line6 {
    right: 8rem;
    top: 340px;
    transform: rotate(-39.85deg);
    @media screen and (max-width: 1218px) {
      transform: rotate(-146.31deg);
      top: 41rem;
      right: 8.5rem;
      width: 67px;
    }
  }
`;
